import { createSlice } from "@reduxjs/toolkit"

const chargingSessionsSlice = createSlice({
    name: "chargingSessions",
    initialState: {
        showColumns: [],
    },
    reducers: {
        setShowColumns: (state, { payload: { columns } }) => {
            state.showColumns = columns
        },
    },
})
export const { setShowColumns } = chargingSessionsSlice.actions
export default chargingSessionsSlice.reducer
